import {Button, ButtonGroup, Grid, TextField, Typography} from "@mui/material";
import {DefaultInfoV1Props} from "@models/DefaultProps.ts";
import {ISolicitacaoOrcamentoRastreio} from "@models/orcamento/ISolicitacaoOrcamentoRastreio.ts";
import {useAlert} from "@contexts/hooks/useAlert.ts";
import {useGeneral} from "@contexts/GeneralContext.tsx";
import {UsuarioInfoTextField} from "@components/contas/usuario/UsuarioInfoTextField.tsx";
import {DateTimeField} from "@mui/x-date-pickers";
import {FornecedorInformacaoFromId} from "@components/fornecedores/FornecedorInformacao.tsx";
import {Cancel, LocalShipping} from '@mui/icons-material'
import {_OrcamentosEndpoints} from "@localization/siteMap/endpoints/_OrcamentosEndpoints.ts";
import {useApi} from "@contexts/hooks/api/useApi.ts";
import {statusOrcamentoColor} from "@models/solicitacoes/statusOrcamentoColor.ts";
import {useEffect, useState} from "react";
import dayjs from "dayjs";

interface CodigoRastreioGridProps extends Omit<DefaultInfoV1Props<ISolicitacaoOrcamentoRastreio>, 'variant'> {
    events?: {
        onUpdate?: (value: ISolicitacaoOrcamentoRastreio) => void;
    }
}


export function CodigoRastreioGrid(props: CodigoRastreioGridProps) {
    const {Get} = useApi()
    const {adjustSizeLevel} = useGeneral()
    const {createAlertFromResponse} = useAlert()
    const {events} = props;
    const {onUpdate} = events || {};

    const [value, setValue] = useState<ISolicitacaoOrcamentoRastreio | undefined>(props.value)

    useEffect(() => {
        setValue(props.value)
    }, [props.value])

    return (value != null && <Grid container>
        <Grid size={2}><TextField label={'Id'} value={value.id}/></Grid>
        <Grid size={adjustSizeLevel({
            md: 6,
            sm: 10
        })}>
            <TextField label={'Codigo'} value={value.codigoRastreio}/></Grid>
        <Grid size={adjustSizeLevel({
            md: 4,
            sm: 12
        })}>
            <TextField label={'Id'} value={value.status} color={statusOrcamentoColor(value.status)}
                       error={value.status == "Cancelado"} disabled/>
        </Grid>
        <Grid size={6}>
            <Typography>
                <UsuarioInfoTextField label={'Criado por'} displayValue={(x) => x.id + ' ' + x.nome.split(' ')[0]}
                                      refId={value.usuarioInclusaoId}/>
            </Typography>
        </Grid>
        <Grid size={6}>
            <DateTimeField label={'Criado em'} fullWidth value={dayjs(value.dataInclusao)}/>
        </Grid>

        {value.usuarioAlteracaoId && <><Grid size={6}>
            <UsuarioInfoTextField label={'Atualizado por'} displayValue={(x) => x.id + ' ' + x.nome.split(' ')[0]}
                                  refId={value.usuarioAlteracaoId}/>
        </Grid>
            <Grid size={6}>
                <DateTimeField label={'Atualizado em'} fullWidth value={dayjs(value.dataAlteracao)}/>
            </Grid></>}
        {value.transportadoraId && <Grid size={6}>
            <FornecedorInformacaoFromId variant={'textfield'} label={'Transportadora'} value={value.transportadoraId}/>
        </Grid>}
        {<Grid size={(value.transportadoraId ? 6 : 12)}>
            <DateTimeField label={'Previsão de entrega'} disabled fullWidth value={dayjs(value.dataPrevisaoEntrega)}/>
        </Grid>}
        <Grid size={12} mt={1}>
            <Grid container justifyContent={'space-between'}>
                <Grid/>
                <Grid container>
                    <ButtonGroup>
                        <Button color={'success'} disabled={value.status != 'Pendente'} onClick={() => {
                            Get(_OrcamentosEndpoints.FinalizaRastreamento({rastreamentoId: value.id})).then(x => {
                                createAlertFromResponse(x)
                                if (onUpdate != null)
                                    onUpdate(x.items)
                            })
                        }} endIcon={<LocalShipping/>}>
                            Confirmar entrega
                        </Button>
                        <Button color={'error'} endIcon={<Cancel/>}
                                onClick={() => {
                                    Get(_OrcamentosEndpoints.DisableRastreamento({rastreamentoId: value.id})).then(x => {
                                        createAlertFromResponse(x)
                                        if (onUpdate != null)
                                            onUpdate(x.items)
                                    })
                                }}
                                disabled={value.status != 'Pendente'}>Cancelar
                            codigo de rastreio</Button>
                    </ButtonGroup>
                </Grid>
            </Grid>
        </Grid>
    </Grid>)
}